import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import EditableOption from "~/components/molecules/EditableOption/EditableOption";
import { useCheckoutStore } from "~/stores/checkout/useCheckoutStore";
import PaymentOptionModal from "../PaymentOptionModal/PaymentOptionModal";

type EditablePaymentOptionProps = { editable?: boolean };

const EditablePaymentOption = ({ editable }: EditablePaymentOptionProps) => {
  const [selectedPaymentOption] = useCheckoutStore((state) => [
    state.selectedPaymentOption,
  ]);
  const [open, setOpen] = useState(false);

  const showModal = () => setOpen(true);

  return (
    <AnimatePresence>
      {open && <PaymentOptionModal key="modal" open={open} setOpen={setOpen} />}
      <EditableOption
        key="editableOption"
        onClick={showModal}
        title={selectedPaymentOption?.name ?? "Please select"}
        level={2}
        className="text-black"
        editable={editable}
      />
    </AnimatePresence>
  );
};

export default EditablePaymentOption;
